export const ICON_SIZE = 18

export const EMPTY_INFO = '???'
